import axios from '@/plugins/axios';
import enumerateArray from '@/helpers/enumerateArray';

const initialState = {
  list: [],
  currentPage: 1,
  lastPage: 1,
  perPage: 100,
  statuses: [],
  categories: [],
  appeal: [],
  employees: [],
  cars: [],
};

const actions = {
  async fetchList({ commit }, params) {
    try {
      const token = localStorage.getItem('token') || '';
      const lang = localStorage.getItem('language') || '';
      const { data } = await axios.get('appeals', {
        headers: { Authorization: `Bearer ${token}`, Lang: lang },
        params,
      });

      const appeals = {
        ...data.data.appeals,
        data: enumerateArray(
          data.data.appeals.data,
          data.data.appeals.current_page,
          data.data.appeals.per_page,
        ),
      };
      commit('setListData', appeals);

      return data;
    } catch (error) {
      return error;
    }
  },

  async fetchStatuses({ commit }) {
    try {
      const token = localStorage.getItem('token') || '';
      const lang = localStorage.getItem('language') || '';
      const { data } = await axios.get('appeals/statuses', {
        headers: { Authorization: `Bearer ${token}`, Lang: lang },
      });

      const statuses = data.data.map((item, idx) => ({ name: item, id: idx }));
      commit('setStatuses', statuses);

      return data;
    } catch (error) {
      return error;
    }
  },
  
  async fetchCategories({ commit }) {
    try {
      const token = localStorage.getItem('token') || '';
      const lang = localStorage.getItem('language') || '';
      const { data } = await axios.get('appeals/categories', {
        headers: { Authorization: `Bearer ${token}`, Lang: lang },
      });

      const categories = data.data.map((item, idx) => ({ name: item, id: idx }));
      commit('setCategories', categories);

      return data;
    } catch (error) {
      return error;
    }
  },
  
  async fetchCars({ commit }) {
    try {
      const token = localStorage.getItem('token') || '';
      const lang = localStorage.getItem('language') || '';
      const { data } = await axios.get('appeals/cars', {
        headers: { Authorization: `Bearer ${token}`, Lang: lang },
      });
      const cars = data.data.map((item, idx) => ({ number: item.number, id: item.id }));
      commit('setCars', cars);
      return data;
    } catch (error) {
      return error;
    }
  },

  async fetchEmployees({ commit }, params) {
    try {
      const token = localStorage.getItem('token') || '';
      const lang = localStorage.getItem('language') || '';
      const { data } = await axios.get('appeals/employees', {
        headers: { Authorization: `Bearer ${token}`, Lang: lang },
        params,
      });

      const employees = data.data.map((item, idx) => ({ name: item.name, id: item.user_id }));
      commit('setEmployees', employees);

      return data;
    } catch (error) {
      return ErrorHandle(error, this);
    }
  },
  
  async updateItem(_, { id, params }) {
    try {
      const token = localStorage.getItem('token') || '';
      const lang = localStorage.getItem('language') || '';
      await axios.put(`appeals/${id}`, params, {
        headers: { Authorization: `Bearer ${token}`, Lang: lang },
      });

      return { success: true };
    } catch {
      return { error: true };
    }
  },
  
  async sendMessage(_, { id, params }) {
    try {
      const token = localStorage.getItem('token') || '';
      const lang = localStorage.getItem('language') || '';
      await axios.post(`appeals/sendMessage/${id}`, params, {
        headers: { Authorization: `Bearer ${token}`, Lang: lang },
      });

      return { success: true };
    } catch {
      return { error: true };
    }
  },
  
  async fetchItem(_, id) {
    try {
      const token = localStorage.getItem('token') || '';
      const lang = localStorage.getItem('language') || '';
      const { data }  = await axios.get(`appeals/${id}`, {
        headers: { Authorization: `Bearer ${token}`, Lang: lang },
      });
      
      return data.data;
    } catch (error) {
      return error;
    }
  },

  async addNew(_, formData) {
    try {
      const token = localStorage.getItem('token') || '';
      const lang = localStorage.getItem('language') || '';
      
      let response = await axios.post('appeals', formData, {
        headers: { Authorization: `Bearer ${token}`, Lang: lang },
      });
      return { message: response.data.data.message };
    } catch (error) {
      const msg = error.response
        ? error.response.data.error.message
        : error.message;

      return { error: msg };
    }
  },
};

const mutations = {
  setList(state, payload) {
    state.list = payload;
  },

  setListData(state, payload) {
    state.list = payload.data;
    state.currentPage = payload.current_page;
    state.lastPage = payload.last_page;
    state.perPage = payload.per_page;
  },

  setStatuses(state, payload) {
    state.statuses = payload;
  },
  
  setCategories(state, payload) {
    state.categories = payload;
  },
  
  setAppeal(state, payload) {
    state.appeal = payload;
  },
  
  setEmployees(state, payload) {
    state.employees = payload;
  },
  
  setCars(state, payload) {
    state.cars = payload;
  },
};

export default {
  namespaced: true,
  state: initialState,
  actions,
  mutations,
};
